// Leaf module (no imports) so the filter-model sanitizer can share it without entering the
// helpers/store/col-defs import cycle.

export const MONTH_TO_MONTH_TERM = 'Month-to-Month';

// Outside inventory stores the spaced spelling and Salesforce sends 0 or 1; the portal shows one label.
const MONTH_TO_MONTH_TERM_VALUES = new Set(['0', '1', 'month to month', 'month-to-month']);

export const isMonthToMonthTerm = (value: string | number | null | undefined): boolean =>
  MONTH_TO_MONTH_TERM_VALUES.has(
    String(value ?? '')
      .trim()
      .toLowerCase()
  );

// Display only — the spaced spelling is what the outside-inventory schema accepts, so it must survive in the data.
export const termLabel = (value: string | number | null | undefined): string => {
  if (isMonthToMonthTerm(value)) return MONTH_TO_MONTH_TERM;
  const term = String(value ?? '');
  // Case-insensitive: benchmark uploads spell it "12 months", and appending to those reads as "12 months Months".
  return !term || term.toLowerCase().includes('month') ? term : `${term} Months`;
};
